import { useState, useEffect } from 'react';
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, IconButton, DialogContent, TextField, DialogActions, Alert, Stack, Autocomplete, Button, Typography } from '@mui/material';
import { CloseSquare } from 'iconsax-react';
import ManageTagsModal from './manage-tags-modal';

const SettingsModal = ({ show, setShow, uiStore, settings, setSettings, findPeople = false }) => {
    const { error, languages } = uiStore
    const [loading, setLoading] = useState(false);
    const [nameFormat, setNameFormat] = useState(settings.nameFormat);
    const [firstLang, setFirstLang] = useState(settings.firstLang);
    const [secondLang, setSecondLang] = useState(settings.secondLang);
    const [showTagsModal, setShowTagsModal] = useState(false);

    const confirm = async () => {
        setLoading(true);
        setSettings({
            nameFormat,
            firstLanguage: firstLang,
            secondLanguage: secondLang
        });
        await uiStore.updateSettings({
            nameFormat,
            firstLang,
            secondLang
        });
        setShow(false);
        setLoading(false);
    };

    const showTags = () => {
        setShow(false);
        setShowTagsModal(true);
    }

    const hideTigs = () => {
        setShowTagsModal(false);
        setShow(true);
    }

    useEffect(() => {
        setFirstLang(settings.firstLanguage)
        setSecondLang(settings.secondLanguage);
        setNameFormat(settings.nameFormat);

    }, [settings])


    return (
        <>
            <Dialog
                open={show}
                onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
                fullWidth
                maxWidth='xs'
            >
                <DialogTitle>
                    Settings
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {error &&
                        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
                    }
                    <Stack spacing={3} sx={{ mt: 2 }}>
                        <Autocomplete
                            options={['First Last', 'Last First']}
                            renderInput={(params) => <TextField {...params} label="Name Format" />}
                            value={nameFormat}
                            onChange={(e, value) => setNameFormat(value)}
                            disableClearable
                        />
                        <Autocomplete
                            options={languages || []}
                            renderInput={(params) => <TextField {...params} label="First Choice Language" />}
                            value={firstLang}
                            onChange={(e, value) => setFirstLang(value)}
                            disableClearable
                        />
                        <Autocomplete
                            options={languages || []}
                            renderInput={(params) => <TextField {...params} label="Second Choice Language" />}
                            value={secondLang}
                            onChange={(e, value) => setSecondLang(value)}
                            disableClearable
                        />
                    </Stack>

                    {!findPeople && <>
                        <Typography sx={{ mt: 3 }}>Tags Management</Typography>
                        <Button onClick={showTags} sx={{ mt: 1 }} variant='contained' color='lightPrimary'>Manage Tags</Button>
                    </>
                    }

                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={loading} onClick={() => setShow(false)} variant="contained" color="lightblue">
                        Cancel
                    </LoadingButton>
                    <LoadingButton loading={loading} onClick={confirm} variant="contained" color="primary">
                        Save
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            {!findPeople && <ManageTagsModal uiStore={uiStore} setShow={showTags} close={hideTigs} show={showTagsModal} />}
        </>
    );
};

export default SettingsModal;